function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUhpc(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M12.93 2.039l7.437 4.344c.58.329.93.963.93 1.62v8.22a1.84 1.84 0 01-.93 1.62l-7.437 4.344a1.876 1.876 0 01-1.86 0l-7.437-4.344a1.868 1.868 0 01-.93-1.62v-8.22c0-.68.35-1.291.93-1.62l7.437-4.344a1.768 1.768 0 011.86 0zM6.416 10.07v5.189l4.203 2.335a.5.5 0 00.743-.438V12.82L6.416 10.07zm6.663 2.992a.48.48 0 00-.473.394l-.008.086v3.643a.48.48 0 00.637.455l.08-.036 3.435-1.929a.48.48 0 00.053-.804l-.074-.045-3.436-1.714a.48.48 0 00-.214-.05zM11.98 5.986L6.945 8.783l5.035 2.8 5.036-2.8-5.036-2.797z"
  }));
}

SvgUhpc.clsName = 'icon-www__uhpc';
SvgUhpc.remarkName = 'unknown';
export default SvgUhpc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uhpc.js
// module id = 2484
// module chunks = 17 18